import { render, staticRenderFns } from "./SessionMessageSetup.vue?vue&type=template&id=0008d85a"
import script from "./SessionMessageSetup.vue?vue&type=script&lang=js"
export * from "./SessionMessageSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports